const formatFileSize = (bytes) => {
  if (!bytes) return null;
  const k = 1024;
  const sizes = ["Б", "КБ", "МБ", "ГБ"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = Math.round((bytes / Math.pow(k, i)) * 10) / 10;
  return `${size} ${sizes[i]}`;
};

export default formatFileSize;
